import gql from 'graphql-tag'

export default gql`
    fragment MultipleLinkFieldContent on MultipleLinkField {
        links {
            url
            newTab
            queryParameters
            references {
                ... on Page {
                    id
                    type
                    title
                }
            }
        }
    }
`
